import * as signalR from "@microsoft/signalr";
import { LoaderFunction } from "react-router-dom";

export const importStatusLaoder: LoaderFunction = async (args) => {
  const hubUrl = `${process.env.REACT_APP_API_WEB_SOCKET}/chathub/exam?examId=${args.params.examId}`;
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => localStorage.getItem("jwtToken") || "",
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Information)
    .build();
  await connection.start();
  connection.onreconnecting((error) => {
    console.log("SignalR bağlantısı yeniden kuruluyor:", error);
  });

  connection.onreconnected((connectionId) => {
    console.log("SignalR bağlantısı yeniden kuruldu:", connectionId);
  });

  connection.onclose((error) => {
    console.log("SignalR bağlantısı kapandı:", error);
  });
  // Bağlantıyı başlat
  console.log("SignalR bağlantısı kuruldu");

  return connection;
};
